export default function FieldTextbox({label,val,field,fieldInner,index,indexInner,align,type,theme,review,changeEvent}){
    return(
        <div className="import-field-block">
            {label!="" && <div className="import-field-label">{label}</div>}
            <input className={"import-field-textbox"+(align=="right"?" import-field-textbox-right":"")+(theme=="alt"?" import-field-textbox-alt":"")+(review==true?" import-field-review":"")} value={val} onChange={(value)=>{changeEvent(value,index,field,fieldInner,indexInner,type)}} />
        </div>
    )
}